const statusMapping = {
  0: "Pending",
  5: "Ready",
  10: "Completed",
};

export default statusMapping;
